import React from 'react';
// import PropTypes from 'prop-types';
import styles from './SearchDropdownRegion.module.scss';

import { useContextState } from '../StateProvider';
import SearchDropdown from '../SearchDropdown';
import isEmpty from '../../utils/isEmpty';
import { useTranslation } from 'next-i18next';

const SearchDropdownRegion = () => {
    const { t } = useTranslation('common');
    let [{ regions, activeRegions } = {}, dispatch] = useContextState();

    regions = regions || [];

    if (isEmpty(regions) || regions.length < 2) {
        return null;
    }

    const getRegionNameByPath = (path) => {
        const region = regions.filter((item) => item.path === path)[0];
        return region.title;
    };

    return (
        <div className={styles['SearchDropdownRegion']}>
            <SearchDropdown
                items={regions}
                activeItems={activeRegions}
                getActiveItemTitle={(path) => getRegionNameByPath(path)}
                dropdownLabel={t('search.regionDropdownLabel')}
                onItemClick={(item) => {
                    let payload;
                    if (activeRegions.indexOf(item.path) > -1) {
                        payload = [];
                    } else {
                        payload = [item.path];
                    }
                    dispatch({
                        type: 'toggle_active_region',
                        payload: payload,
                    });
                    dispatch({
                        type: 'set_current_page',
                        payload: 1,
                    });
                    dispatch({
                        type: 'set_searching',
                        payload: true,
                    });
                }}
            />
        </div>
    );
};

SearchDropdownRegion.propTypes = {};

export default SearchDropdownRegion;
